<template>
  <div class="content">
    
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <ul class="navbar-nav">
        <li class="nav-item">
          <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'voucher'}" :to="{ name: 'voucher' }" v-on:click.native="data.tabActive = 'voucher'">
            Voucherku
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'voucher-tarif'}" :to="{ name: 'voucher-tarif' }" v-on:click.native="data.tabActive = 'voucher-tarif'">
            Tarif Voucher
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'voucher-kang'}" :to="{ name: 'voucher-kang' }" v-on:click.native="data.tabActive = 'voucher-kang'">
            Kang Voucher
          </router-link>
        </li>
      </ul>
    </nav>

    <transition name="slide-fade" mode="out-in"><router-view></router-view></transition>
    
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
    const data = reactive({
      tabActive: "voucher"
    })

    return {
      data
    }
  },
  mounted () {

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/voucher/main.vue